// extracted by mini-css-extract-plugin
export var errorIcon = "_kv-1";
export var nameLogo = "_kv-0";